export const getPriceWithCurrency = (price: number, currency: string) =>
  new Intl.NumberFormat(
    typeof window !== 'undefined' ? navigator.language : 'ru-RU',
    {
      style: 'currency',
      currency,
      minimumFractionDigits: price % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }
  ).format(price);
